import Setting from './index';
import Currency from './Currency';
import TradePair from './TradePair';
import BannerNew from './BannerNew';
import Content from './Content';
import WalletSwitch from './WalletSwitch';
import ProcessorConfig from './ProcessorConfig';
import CurrencyIntroduction from './CurrencyIntroduction';
import SiteConf from './Siteconf';
import Poster from './Poster';
import News from './News';
import Current from './Current';
import Push from './push';
import CoinRemind from './CoinRemindConfig';
import WalletAccount from './WalletAccount';
import NewsEditor from './News/components/editor';
import OtcAdvertising from './otc/advertising';
import OtcFee from './otc/fee';
import PettyCash from './PettyCash';
import AddressManage from './AddressManage';
import OtcStatistic from './otc/otcStatistic';
import TradeRange from './TradeRange';
import PairBonus from './PairBonus';

export default {
  path: '/home/setting',
  component: Setting,
  children: [
    { path: '/home/setting/currency', component: Currency },
    { path: '/home/setting/tradePair', component: TradePair },
    { path: '/home/setting/BannerNew', component: BannerNew },
    { path: '/home/setting/content', component: Content },
    { path: '/home/setting/walletSwitch', component: WalletSwitch },
    { path: '/home/setting/processorConfig', component: ProcessorConfig },
    { path: '/home/setting/siteconf', component: SiteConf },
    {
      path: '/home/setting/currencyIntroduction',
      component: CurrencyIntroduction
    },
    { path: '/home/setting/poster', component: Poster },
    { path: '/home/setting/news', component: News },
    { path: '/home/setting/news/editor', component: NewsEditor },
    { path: '/home/setting/current', component: Current },
    { path: '/home/setting/push', component: Push },
    { path: '/home/setting/coinRemind', component: CoinRemind },
    { path: '/home/setting/walletAccount', component: WalletAccount },
    { path: '/home/setting/otc/advertising', component: OtcAdvertising },
    { path: '/home/setting/otc/fee', component: OtcFee },
    { path: '/home/setting/petty/cash', component: PettyCash },
    { path: '/home/setting/otc/statistic', component: OtcStatistic },
    { path: '/home/setting/trade/range', component: TradeRange },
    { path: '/home/setting/pairbonus', component: PairBonus },
    { path: '/home/setting/addressManage', component: AddressManage }
  ]
};
